import { chains, } from "../chains";

/** @bracket/chainography supported chain ids */
export declare type ValidChainId = keyof typeof import("../chains").chains;



/**
 * Checks if a value is a valid chain ID supported by the chainography library
 * 
 * @param chain - The value to check
 * @returns True if the value is a valid chain ID, false otherwise
 * 
 * @example
 * ```ts
 * if (isValidChainId(1)) {
 *   // Chain ID 1 (Ethereum Mainnet) is valid
 * }
 * ```
 */
export const isValidChainId = ( chain: unknown ): chain is ValidChainId => {
	if(typeof chain === "number") {
    return Object.keys(chains).includes(chain.toString());
	}
	return false;
}
